// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main":"css-1AeoWdV3Rf"};